import { ReactNode, FC } from 'react';
import { Stack } from '@fluentui/react';
import Loader from './Loader/Loader';
import styles from '../pages/layout/Layout.module.css';

type TPage = FC<{
  children: ReactNode;
  loading?: boolean;
}>;

const Page: TPage = ({ children, loading = false }) => (
  <div className={styles.container}>
    <Stack horizontal className={styles.chatRoot}>
      <Stack horizontal tokens={{ childrenGap: 20 }} style={{ width: '100%' }}>
        <Stack.Item grow={1} style={{ height: '100%' }}>
          <div
            style={{
              height: '100%',
              padding: '2rem',
              borderRadius: '1rem',
              background: 'white',
            }}
          >
            {loading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                }}
              >
                <Loader />
              </div>
            ) : (
              children
            )}
          </div>
        </Stack.Item>
      </Stack>
    </Stack>
  </div>
);

export default Page;
